import HttpClient from "./HttpClient";

export type ClientExportKind = "person-list-csv" | "invoice-pdf";

// Exports created in the browser (CSV, PDF) are invisible to the server, so
// they are reported to the access log (task 029). Fire-and-forget: a failed
// report must never block the export itself.
export function reportExport(
  kind: ClientExportKind,
  payload: { personIds?: number[]; fields?: string[]; details?: Record<string, unknown> } = {},
): void {
  new HttpClient("/audit").postAction("export", { kind, ...payload }).catch(() => {});
}
